import { render, staticRenderFns } from "./OrderShipmentUpdate.vue?vue&type=template&id=e5c71e82&"
import script from "./OrderShipmentUpdate.vue?vue&type=script&lang=js&"
export * from "./OrderShipmentUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5c71e82')) {
      api.createRecord('e5c71e82', component.options)
    } else {
      api.reload('e5c71e82', component.options)
    }
    module.hot.accept("./OrderShipmentUpdate.vue?vue&type=template&id=e5c71e82&", function () {
      api.rerender('e5c71e82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/App/VPL/MyOrder/OrderDetail/OrderShipmentUpdate.vue"
export default component.exports